(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FindifyAnalytics", [], factory);
	else if(typeof exports === 'object')
		exports["FindifyAnalytics"] = factory();
	else
		root["FindifyAnalytics"] = factory();
})(self, function() {
return 